module.exports = __webpack_public_path__ + "static/media/file-invoice-dollar.69052305.svg";